/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SchemasSystemSimResultData } from './SchemasSystemSimResultData';
import {
    SchemasSystemSimResultDataFromJSON,
    SchemasSystemSimResultDataFromJSONTyped,
    SchemasSystemSimResultDataToJSON,
    SchemasSystemSimResultDataToJSONTyped,
} from './SchemasSystemSimResultData';

/**
 * 観測所ごとのsim_result
 * @export
 * @interface StationSimResult
 */
export interface StationSimResult {
    /**
     * シミュレーション結果データ
     * @type {Array<SchemasSystemSimResultData>}
     * @memberof StationSimResult
     */
    simResult?: Array<SchemasSystemSimResultData>;
    /**
     * アンサンブル結果データ（配列の配列）
     * @type {Array<Array<SchemasSystemSimResultData>>}
     * @memberof StationSimResult
     */
    simResults?: Array<Array<SchemasSystemSimResultData>>;
}

/**
 * Check if a given object implements the StationSimResult interface.
 */
export function instanceOfStationSimResult(value: object): value is StationSimResult {
    return true;
}

export function StationSimResultFromJSON(json: any): StationSimResult {
    return StationSimResultFromJSONTyped(json, false);
}

export function StationSimResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationSimResult {
    if (json == null) {
        return json;
    }
    return {
        
        'simResult': json['sim_result'] == null ? undefined : ((json['sim_result'] as Array<any>).map(SchemasSystemSimResultDataFromJSON)),
        'simResults': json['sim_results'] == null ? undefined : json['sim_results'],
    };
}

export function StationSimResultToJSON(json: any): StationSimResult {
    return StationSimResultToJSONTyped(json, false);
}

export function StationSimResultToJSONTyped(value?: StationSimResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sim_result': value['simResult'] == null ? undefined : ((value['simResult'] as Array<any>).map(SchemasSystemSimResultDataToJSON)),
        'sim_results': value['simResults'],
    };
}

